var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"width":_vm.width},on:{"click:outside":_vm.closeModal},model:{value:(_vm.abrirDialog),callback:function ($$v) {_vm.abrirDialog=$$v},expression:"abrirDialog"}},[_c('v-alert',{staticClass:"mb-0 white--text text-center",attrs:{"border":"left","color":_vm.color}},[_vm._v(" "+_vm._s(_vm.mensagem)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }